import { EngineFormItem } from '@models/client-portal/engine-client-intake';

export class CreateIntakeFormItems {
	static readonly type = '[Intake Form Items] Create Items';
	constructor(public items: EngineFormItem[]) {}
}
